import { AppNameComponent } from './data-widgets/app-name.component';
import { BigNumberDataComponent } from './data-widgets/big-number-data.component';
import { GridHeaderComponent } from './data-widgets/grid-header.component';
import { RankDataComponent } from './data-widgets/rank-data.component';
import { YesnoComponent } from './data-widgets/yesno.component';
import { ReportConfig } from './REPORT_CONFIG';
import { CTV_OPTIONS } from './REPORT_CONFIG_CONST';

export const REPORT_CONFIG_PUBLISHER_COPPA: ReportConfig = {
  key: 'publisher-coppa',
  heading: 'Child-Directed Apps',
  title: 'Popular Apps Registered in {countryCode}',
  formTitle: 'Child Directed Apps rankings',
  pageTitle: 'Top 100 Likely Child-directed Apps',
  pageMeta:
    'Top 100 Likely Child-directed Apps for {type} in the {platformName}',
  showTitle: true,
  reportId: 'coppaIndex',
  notHideDataIfNA: true,
  permissions: ['mrtSellerTrustIndex', 'freemium', 'anonymous'],
  rowLimit: 10,
  fadeStart: 5,
  mainFilterItems: [
    {
      key: 'platformName',
      label: 'OS',
      selected: {
        label:
          '<img class="mr-2" src="/assets/images/google-play.svg" alt="Google Play Icon"/> Google Play',
        value: 'android'
      },
      groups: ['app'],
      hidden: false,
      type: 'toggle-filter',
      options: [
        {
          label:
            '<img class="mr-2" src="/assets/images/google-play.svg" alt="Google Play Icon"/> Google Play',
          value: 'android'
        },
        {
          label:
            '<img class="mr-2" src="/assets/images/apple.svg" alt="App Store Icon"/> App Store',
          value: 'ios'
        }
      ]
    },
    {
      key: 'platformName',
      label: 'OS',
      selected: CTV_OPTIONS[0],
      groups: ['ctv'],
      hidden: false,
      type: 'toggle-filter',
      options: [...CTV_OPTIONS]
    },
    {
      key: 'countryCode',
      apiKey: 'country',
      label: 'Country',
      selected: { label: 'All Countries', value: 'GLOBAL' },
      hidden: false,
      dependencies: [
        {
          key: 'date'
        },
        {
          key: 'platformName'
        }
      ],
      options: [{ label: 'All Countries', value: 'GLOBAL' }],
      default: { label: 'All Countries', value: 'GLOBAL' }
    },
    {
      key: 'date',
      label: 'Month',
      selected: null,
      hidden: false,
      dependencies: [
        {
          key: 'platformName'
        }
      ],
      options: []
    }
  ],
  gridHeaders: [
    {
      label: 'Rank',
      key: 'rank',
      sort: '',
      sortDefault: true,
      sortColumnKey: '',
      hoverKey: '',
      template: null,
      widgetComponent: RankDataComponent,
      hidden: false,
      headerWidgetComponent: GridHeaderComponent
    },
    {
      label: 'App Name',
      key: 'appTitle',
      sort: '',
      sortDefault: false,
      sortColumnKey: null,
      hoverKey: '',
      widgetComponent: AppNameComponent,
      template: null,
      hidden: false,
      headerWidgetComponent: GridHeaderComponent
    },
    {
      label: 'Estimated Downloads',
      key: 'downloads',
      showIfReq: {
        isFilter: {
          platform: 'android'
        }
      },
      sort: '',
      sortDefault: false,
      sortColumnKey: null,
      hoverKey: '',
      format: '0a,text-uppercase',
      template: null,
      widgetComponent: BigNumberDataComponent,
      hidden: false,
      lockIfAnonymous: true,
      headerWidgetComponent: GridHeaderComponent
    },
    {
      label: 'Assessment Type',
      key: 'manuallyReviewed',
      sort: '',
      sortDefault: false,
      sortColumnKey: null,
      hoverKey: '',
      template: null,
      hidden: false,
      format: 'manual-review',
      widgetComponent: YesnoComponent,
      headerWidgetComponent: GridHeaderComponent
    },
    {
      label: 'Privacy Policy Detected',
      key: 'privacyPolicyDetected',
      sort: '',
      sortDefault: false,
      sortColumnKey: null,
      hoverKey: '',
      template: null,
      hidden: false,
      lockIfAnonymous: true,
      widgetComponent: YesnoComponent,
      headerWidgetComponent: GridHeaderComponent
    },
    {
      label: 'Sensitive Permissions Detected',
      key: 'sensitivePermissions',
      sort: '',
      sortDefault: false,
      sortColumnKey: null,
      hoverKey: '',
      template: null,
      hidden: false,
      lockIfAnonymous: true,
      format: 'rev',
      widgetComponent: YesnoComponent,
      headerWidgetComponent: GridHeaderComponent
    },
    {
      label: 'Transmits Location',
      key: 'transmitsLocation',
      sort: '',
      sortDefault: false,
      sortColumnKey: null,
      hoverKey: '',
      template: null,
      hidden: false,
      lockIfAnonymous: true,
      format: 'rev',
      widgetComponent: YesnoComponent,
      headerWidgetComponent: GridHeaderComponent
    },
    {
      label: 'Transmits Residential IP',
      key: 'transmitsResidentialIP',
      sort: '',
      sortDefault: false,
      sortColumnKey: null,
      hoverKey: '',
      template: null,
      hidden: false,
      lockIfAnonymous: true,
      format: 'rev',
      widgetComponent: YesnoComponent,
      headerWidgetComponent: GridHeaderComponent
    }
  ]
};
